export default {
  // Ungrouped: [
  //   "fromCohort",
  //   "tumorClass",
  //   "Age",
  //   "Gender",
  //   "consent_race",
  //   "Vital status",
  //   "Hypertension",
  //   "Tumor grade",
  //   "BMI",
  //   "Weight_at_surgery",
  //   "Alcohol consumption",
  //   "Smoking status",
  //   "Country",
  //   "Tumor stage",
  //   "methyl_type2",
  //   "im_type",
  //   "im_type_discovery",
  //   "wgii high",
  // ],
  Ungrouped: [
    
    "Diagnosis",
    // "HARMONY_First_Diagnosis",
    "Sex",
    // "HARMONY_Simple_Diagnosis",
    // "HARMONY_WHO_Grade",
    // "HARMONY_age",
    "Age class",
    // "HARMONY_age_class_name_derived", 
    // "HARMONY_dasc", 
    // "HARMONY_os", 
    // "HARMONY_os_status", 
    // "HARMONY_pfs", 
    // "HARMONY_pfs_status", 
    // "HARMONY_treat_status", 
    "Tumor location", 
    "Protein Subtype",
    "ATRX",
    "TP53",
    "H3-3A",
    "IDH1",
    "NF1",
  ],
  Mutation: [
  ],

    
    
  // ],
  // Chromosome_gain: [],
  // Chromosome_loss: [],
  Numerical: []
};
